import { FC, ReactNode } from "react";
import { FieldValues, FormProvider, UseFormReturn } from "react-hook-form";
import BackButton from "@/components/uix/BackButton/BackButton";
import CustomButton from "@/components/uix/CustomButton/CustomButton";
import { MdSaveAs } from "react-icons/md";
import Loader from "@/components/uix/Loader/Loader";

interface MasterFormProps<T extends FieldValues> {
  methods: UseFormReturn<T>;
  schema: any;
  onSubmit: (data: T) => Promise<void>;
  children: ReactNode;
  textButton?: string;
}

const FormMaster: FC<MasterFormProps<any>> = ({ methods, onSubmit, children, textButton }) => {
  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className='space-y-2'>
        {children}
        <div className='flex items-center gap-2'>
          <CustomButton
            type='submit'
            variant='outline'
            className='h-2 p-2 py-3 bg-primary/50 hover:bg-primary'
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <Loader type='ClipLoader' />
            ) : (
              <div className='flex items-center gap-1'>
                {textButton ? textButton : "Enregistré"} <MdSaveAs className='h-4 w-4' />
              </div>
            )}
          </CustomButton>
          <BackButton />
        </div>
      </form>
    </FormProvider>
  );
};

export default FormMaster;
